import '../App.css';

function Footer() {
  return (
    <footer className="text-center py-6 flex flex-col lg:flex-row justify-around items-center w-full">
        <p>&copy; {new Date().getFullYear()} ALICE STEM - Tutti i diritti riservati.</p>
        <img src='/LOGO_ALICE-01.png' width={'150px'}/>
    </footer>
  );
}

export default Footer;